<template>
  <!-- ケアオーケストレータークライアント証明書 -->
  <div id="CODealerSettingClientCertificate">
    <div id="container-center">
      <coSettingNavi v-bind:pageid='"CODealerSettingClientCertificate"' :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' :certificationFlag='this.certificationFlag' :searchConditions='this.searchConditions'></coSettingNavi>
      <settingCertificate  :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' />
      <div style="margin-top:10px;">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/guest/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/guest/careorchestrator/setting/ExternalClientCertificate";

export default {
  name: "CODealerSettingClientCertificate",
  methods: {
    back: function() {
      this.$router.push({ 
        name: "CODealerHospitalSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
  },
  data() {
    let searchConditions = this.$route.params["searchConditions"];
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    return {
      careOrchestratorInstitutionId: careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions: searchConditions,
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingCertificate: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CODealerSettingClientCertificate.vue